<h2>Characteristics</h2>
<p-table #dt [value]="characteristics" [globalFilterFields]="['characteristicType', 'effectiveDate', 'endDate','updatedDate', 'updatedBy']">
    <ng-template pTemplate="caption">
        <div class="row">
            <div class="col-sm-6 col-md-3">
                <input class="mvd_form-control" type="text" autocomplete="off" placeholder="Filter..." (input)="dt.filterGlobal($event.target.value, 'contains')">
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="5">
                No records found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th>Type</th>
            <th class="w--date">Effective Date</th>
            <th class="w--date">Expiration Date</th>
            <th class="w--date">Updated</th>
            <th>Updated By</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
        <tr [pSelectableRow]="data">
            <td>{{data.characteristicType}}</td>
            <td>{{data.effectiveDate | shortDate}}</td>
            <td>{{data.endDate | shortDate}}</td>
            <td>{{data.updatedDate | dateTime}}</td>
            <td class="td--hover-show">{{data.updatedBy}}</td>
        </tr>
    </ng-template>
</p-table>
